import { render, staticRenderFns } from "./AccessDenied.vue?vue&type=template&id=17e5288c&scoped=true&"
var script = {}
import style0 from "./AccessDenied.vue?vue&type=style&index=0&id=17e5288c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e5288c",
  null
  
)

export default component.exports